import {Component, OnInit} from "@angular/core";
import {
    TCIApplicationCreateOption,
    TCITenantAppType,
    TCITenantSelectorType
} from "@tci/common";
import {
    ITCICreateAppComponentInput,
    ITCICreateAppComponentOutput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../../../ng-tenant/tci-tenant-components";
import {AbstractTCITenantComponent} from "../../../ng-tenant/tci-tenant-component";

export class BaseCreateAppV2ComponentInput extends TCITenantComponentInput implements ITCICreateAppComponentInput {
    constructor(private type: TCITenantAppType, protected option: TCIApplicationCreateOption) {
        super();
    }

    /**
     * Get the component tenant type
     */
    getTenantType(): TCITenantAppType {
        return this.type;
    }

    /**
     * Get the component create option
     */
    getCreateOption(): TCIApplicationCreateOption {
        return this.option;
    }
}

export class BaseCreateAppV2ComponentOutput<E> extends TCITenantComponentOutput<E> implements ITCICreateAppComponentOutput<E> {
    constructor() {
        super();
    }
}

@Component({
    selector: TCITenantSelectorType.TCI_CREATE_APP.toString(),
    template: "<div>No template provided by tenant</div>"
})
export class BaseCreateAppV2Component<E, I extends BaseCreateAppV2ComponentInput, O extends BaseCreateAppV2ComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {
    constructor() {
        super();
    }

    ngOnInit(): void {
    }
}
